import { KeyValueObject } from "./KeyValueObject";

export class KeyValueObjectsGroup {

    constructor(groupId: number, objects: KeyValueObject[] = []) {
        this.groupId = groupId;
        this.objects = objects
    }

    groupId: number;
    objects: KeyValueObject[] = [];
}